import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, subtitle, dark = false }) => (
  <div className="max-w-2xl">
    <FadeUp>
      <p className={`font-tech text-xs font-semibold uppercase tracking-[0.28em] ${dark ? "text-sky-400" : "text-sky-600"}`}>
        {eyebrow}
      </p>
    </FadeUp>
    <FadeUp delay={0.08}>
      <h2 className={`mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight ${dark ? "text-white" : "text-slate-900"}`}>
        {title}
      </h2>
    </FadeUp>
    {subtitle && (
      <FadeUp delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>{subtitle}</p>
      </FadeUp>
    )}
  </div>
);
